import { action } from 'ts-action';

export const tableRefreshRequest = action(
  '[Work packages] Table refresh requested',
);
